import { render } from "./LabelPlaneRegions.vue?vue&type=template&id=5c15df3b"
import script from "./LabelPlaneRegions.vue?vue&type=script&lang=js"
export * from "./LabelPlaneRegions.vue?vue&type=script&lang=js"

import "./LabelPlaneRegions.vue?vue&type=style&index=0&id=5c15df3b&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__